import { useMemo, useState } from 'react';
import { MediaCard, PageIntro, ScrollTabs } from '../components/ui';
import { useNavData } from '../components/layout/useNavData';
import { summary } from '../utils/text';

const ALL = 'all';

export default function Services() {
  // Les services sont déjà chargés (et mis en cache) par le header: la page s'affiche sans requête de plus
  const { services, loaded } = useNavData();
  const [filter, setFilter] = useState(ALL);

  const list = useMemo(() => services.filter((s) => s.cover_image?.url), [services]);
  const tabs = useMemo(() => {
    const bySector = new Map<string, { label: string; n: number }>();
    for (const s of list) {
      const name = s.sector?.name?.trim();
      if (!s.sector_id || !name) continue;
      bySector.set(s.sector_id, { label: name, n: (bySector.get(s.sector_id)?.n ?? 0) + 1 });
    }
    return [{ id: ALL, label: 'Tous' }, ...[...bySector].sort((a, b) => b[1].n - a[1].n).map(([id, v]) => ({ id, label: v.label }))];
  }, [list]);
  const shown = filter === ALL ? list : list.filter((s) => s.sector_id === filter);

  return (
    <div id="content">
      <PageIntro eyebrow="Nos services" title="Des services pour chaque étape de votre projet." />

      <section className="bg-white pb-20 text-black md:pb-28">
        <div className="site-container">
          {tabs.length > 2 && <ScrollTabs tabs={tabs} active={filter} onChange={setFilter} className="mb-10 md:mb-14" />}

          {!loaded && (
            <div className="grid gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3" aria-busy>
              {[0, 1, 2].map((n) => <div key={n} className="aspect-[3/2] animate-pulse bg-secondary-200" />)}
            </div>
          )}
          {loaded && shown.length === 0 && <p className="py-10 text-lg text-ink">Aucun service à afficher pour le moment.</p>}
          {shown.length > 0 && (
            <div key={filter} className="grid gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
              {shown.map((s, i) => (
                <MediaCard key={s.id} to={`/services/${s.id}`} image={s.cover_image?.url} title={s.name} eyebrow={s.sector?.name} text={summary(s.description, 130)} delay={(i % 3) * 0.08} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
